// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import './rescheduleVisitStyle.scss'
import classNames from 'classnames'
import editIcon from '../../images/common/editIntake.png'
import { text } from './constants'
import { generateRescheduleMessage } from './rescheduleHelper'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const RescheduleVisit = memo(({ redirectToRescheduleVisitPage, IsVisitTypeAvailable, isPriceChanged, status }) => {
  const disabledMessages = useRef([])
  const [disabledRescheduledReason, setDisabledRescheduledReason] = useState('')
  const [isHovering, setIsHovering] = useState(false)
  const isRescheduleAllowed =
    !isPriceChanged &&
    IsVisitTypeAvailable &&
    status !== text.IN_PROGRESS_STATUS &&
    status !== text.IN_WAITING_ROOM_BACK
  console.log('here', status)
  useEffect(() => {
    if (!isRescheduleAllowed) {
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      disabledMessages.current = generateRescheduleMessage({
        isPriceChanged,
        IsVisitTypeAvailable,
        status,
      })
    }
  }, [])

  const onHover = useCallback(() => {
    if (!isRescheduleAllowed) {
      setDisabledRescheduledReason(`Reason: ${disabledMessages.current.join(' and ')}`)
    } else {
      setDisabledRescheduledReason('')
    }
    setIsHovering(true)
  }, [isRescheduleAllowed, disabledMessages.current])
  return (
    <div
      className='reschedule-visit-edit-img-container'
      role='presentation'
      onFocus={() => {}}
      onMouseOver={onHover}
      onMouseLeave={() => {
        setIsHovering(false)
      }}
      onClick={isRescheduleAllowed ? redirectToRescheduleVisitPage : () => {}}>
      <img
        alt='editIcon'
        src={editIcon}
        className={classNames('reschedule-visit-edit-img', {
          'reschedule-visit-edit-img-disabled': !isRescheduleAllowed,
        })}
      />
      <div className='reschedule-visit-edit-img-tooltip-box' data-state={isHovering ? 'visible' : 'hidden'}>
        {isRescheduleAllowed ? text.RESCHEDULE_VISIT : text.RESCHEDULING_UNAVAILABLE} <br />
        {disabledRescheduledReason}
      </div>
    </div>
  )
})

export default RescheduleVisit
